import React from "react";
import Imgix from "react-imgix";
import Icon from "../Icon";
import Shadow from "../Shadow";

// done except for mobile
const QuoteBlock = ({ block, className }) => (
  <div className="quote-block relative bg-green mv2 mv3-l">
    <Icon path="quote-open" className="quote quote--open absolute top-0 z-1" />
    {block.attributionPhoto ? (
      <div className="w-100 flex items-center flex-column">
        <Imgix
          src={block.attributionPhoto.url}
          className="quote-block__image image-cover top-0 left-0 w-100 bg-green absolute h-100 bg-center"
          imgixParams={{
            crop: "focalpoint",
            auto: ["compress"]
          }}
          htmlAttributes={{
            alt: block.attributionAltText
          }}
        />
        <Shadow />
        <blockquote
          className="quote-block__blockquote p-lead stone-light z-1 ttu tc"
          dangerouslySetInnerHTML={{ __html: block.content }}
        />
        {block.attribution && (
          <p className="quote-block__attribution stone-light h-5 z-1 ttu mt1">
            &ndash; {block.attribution}
          </p>
        )}
      </div>
    ) : (
      <div className="flex items-center flex-column">
        <blockquote
          className="quote-block__blockquote p-lead dark ttu tc"
          dangerouslySetInnerHTML={{ __html: block.content }}
        />
        {block.attribution && (
          <p className="quote-block__attribution dark h-5 ttu">
            &ndash; {block.attribution}
          </p>
        )}
      </div>
    )}
    <Icon
      path="quote-close"
      className="quote quote--close flex absolute bottom-0"
    />
  </div>
);

export default QuoteBlock;



// WEBPACK FOOTER //
// ./src/components/Blocks/QuoteBlock.js